import { useDispatch } from 'react-redux';
import debounce from 'transmute/debounce';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
import { setLineItemBlur } from '../state/lineItemBlursSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DEBOUNCE_DELAY = 200;
const CustomQuantityInput = ({
  id,
  quantity,
  min,
  max,
  error
}) => {
  const dispatch = useDispatch();
  const handleValueChange = debounce(DEBOUNCE_DELAY, event => {
    dispatch({
      type: BuyerOverridesActionTypes.SET_QUANTITY,
      data: {
        id,
        quantity: Number(event.target.value)
      }
    });
    dispatch(setLineItemBlur({
      lineItemId: id,
      isBlurred: true
    }));
  });
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    gap: "200",
    alignItems: "center",
    "data-test-id": "custom-quantity-input",
    maxInlineSize: "100px",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-subtle",
      children: "x"
    }), /*#__PURE__*/_jsx(NumberInput, {
      id: `${id}`,
      name: "line-item-quantity",
      "aria-label": "Line Item quantity",
      onBlur: handleValueChange,
      min: min,
      max: max,
      error: error,
      value: quantity
    })]
  });
};
export default CustomQuantityInput;